export const selectOrderById = (state, id) => {
    return state.shop.orderHistory[`order-${id}`];
};
